import React from 'react';
import { Alert } from '@socialchorus/shared-ui-components';
import './degradation-banner.scss';
import { useTranslation } from 'react-i18next';
/**
 * Degradation Banner component that displays at the top of the page when
 * there is data in cache but network requests are failing.
 * The banner indicates to users that they are viewing cached content while
 * the application is experiencing connectivity issues.
 */
export const DegradationBanner: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div
      className="degradationBannerWrapper"
      aria-live="assertive"
      role="alert"
    >
      <Alert
        title={t('errors.banner_title') || ''}
        description={t('errors.banner_description') || ''}
        type="warning"
        iconName="warning"
        size={'default'}
      />
    </div>
  );
};
